export const projectScopeSections = [
  {
    id: 1,
    text: 'Analysis of an extensive database using SQL Server.',
  },
  {
    id: 2,
    text: 'Development of an algorithm for data-report generation and structuring of prognoses and treatment plans.',
  },
  {
    id: 3,
    text: 'Creation of APIs to communicate with the clients’ databases.',
  },
  {
    id: 4,
    text: 'Creation of algorithms for strict consideration of all data available and configuration of accurate patient treatment plans. ',
  },
]

export const config = {
  title: 'Project Scope',
  text: 'Rendering diagnosing services related to treating complicated cancer cases, the client faced the need to consolidate older patient records with new ones, to put together a comprehensive AI-powered database able to analyze the experience of millions of cancer patients and help oncologists make informed treatment decisions.\n\nModsen developer engineers were asked to join our partner’s in-house team to address the following challenges:',
  projectScopeSections,
}
